import React, { useEffect } from 'react';
import { useSelector } from "react-redux";

const MetaTags = ({defaultLang}) => {
  const xprops = useSelector(state => state);
  if (xprops.language === undefined){
    xprops.language = defaultLang;
  }

  useEffect(() => {
    document.title = xprops.language.metas.title;
    document.querySelector('html').setAttribute('lang', xprops.language.short.toLowerCase());
    document.querySelector('meta[name="description"]').setAttribute("content",xprops.language.metas.description);
    document.querySelector('meta[name="twitter:title"]').setAttribute("content", xprops.language.metas.twitter.title);
    document.querySelector('meta[name="twitter:description"]').setAttribute("content", xprops.language.metas.twitter.description);
    document.querySelector('meta[property="og:title"]').setAttribute("content", xprops.language.metas.og.title);
    document.querySelector('meta[property="og:description"]').setAttribute("content", xprops.language.metas.og.description);
  }, [xprops.language]);

  return null;
};

export default MetaTags;